import fileType from './fileType';
import isBefore from './isBefore';
import isLate from './isLate';
import password from './password';
import vatNumber from './vatNumber';

const validators = {
  fileType,
  isBefore,
  isLate,
  password,
  vatNumber,
};

export default validators;
